var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import { Bookmark, BookmarkActive } from "backpack-ui/dist/components/icon";
import * as cn from "classnames";
import * as React from "react";
import { bookmarkButtonGtmClasses } from "../../utils/gtm";
import { ButtonOutline } from "./buttonOutline";
export var ButtonBookmark = function (_a) {
    var _b = _a.bookmarked, bookmarked = _b === void 0 ? false : _b, className = _a.className, onClick = _a.onClick, rest = __rest(_a, ["bookmarked", "className", "onClick"]);
    return (React.createElement(ButtonOutline, __assign({ className: cn(bookmarkButtonGtmClasses(bookmarked), className), onClick: onClick }, rest),
        bookmarked ? React.createElement(BookmarkActive, null) : React.createElement(Bookmark, null),
        "Save"));
};



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/components/button/buttonBookmark.tsx
// module id = M5T4
// module chunks = 2